import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { tenantActions } from '../../redux/tenant.actions';
import { showSuccesToast } from '../helpers';
import { useDispatch } from 'react-redux';
import moment from 'moment';
const DocStatusTable = ({ open_flow_certificates = [],flowId='' }) => {
    const dispatch =useDispatch()
  return (
    <View style={styles.card}>
      <Text style={styles.title}>Documents Status</Text>

      <View style={styles.table}>
        {/* Header */}
        <View style={[styles.row, styles.headerRow]}>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Certificates</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Status</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Sent On</Text>
          </View>
        </View>

        {/* Rows */}
        {open_flow_certificates.map((certificate, index) => (
          <View key={index} style={styles.row}>
            <View style={styles.cell}>
              <Text>{certificate?.certificate_type}</Text>
            </View>

            <View style={styles.cell}>
              <View
                style={[
                  styles.statusContainer,
                  { borderColor: certificate?.is_seen ? 'green' : 'red' },
                ]}
              >
                <Text style={{
                  color: certificate?.is_seen  ? 'green' : 'red',
                  fontSize: 14,
                }}>
                  {certificate?.is_seen  ? 'Seen' : 'Not Seen'}
                </Text>
              </View>
            </View>

            <View style={styles.cell}>
              <Text>{moment(certificate?.createdAt).format('DD/MM/YYYY') }</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    marginTop: 16,
    padding: 16,
    backgroundColor: 'white',
    borderRadius: 12,
    elevation: 2,
  },
  title: {
    fontSize: 16,
    color: '#3f51b5',
    fontWeight: '600',
    marginBottom: 12,
  },
  table: {
    width: '100%',
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#ddd',
    paddingVertical: 12,
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
  },
  cell: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  headerText: {
    fontWeight: '600',
  },
  statusContainer: {
    borderWidth: 1,
    borderRadius: 12,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
  },
  nudgeButton: {
    backgroundColor: '#9b5de5',
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  nudgeText: {
    color: 'white',
    fontWeight: 'bold',
  },
});

export default DocStatusTable;
